import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { REPORTS_STORE_KEY } from './data/reports-store.state';
import { ReportsReducer } from './data/reports-store.reducer';
import { ReportsEffect } from './data/reports-store.effects';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(REPORTS_STORE_KEY, ReportsReducer), EffectsModule.forFeature([ReportsEffect])],
})
export class SharedFeatureReportsModule {}
